import { useResourceParams } from '@refinedev/core';
import { useMemo } from 'react';
import { Outlet } from 'react-router';

import SpinLoading from '@/components/general/SpinLoading';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { useInitialLoading } from '@/hooks/useInitialLoading';
import { useSelectScrollSearch } from '@/hooks/useSelectScrollSearch';
import { RESOURCES } from '@/Resources';

const ReceptionSection = () => {
  const { action } = useResourceParams();

  useDocumentTitle({
    resourceTitle: 'Recepciones',
    showTitle: 'Recepción {id}',
    editTitle: 'Editar recepción {id}',
    createTitle: 'Nueva recepción',
  });

  const { selectProps: companySelectProps } = useSelectScrollSearch(
    {
      resource: 'empresas',
      optionLabel: (item: any) => item.full_name,

      queryOptions: {
        queryKey: ['empresas'],
      },
    },
    { saveItem: true },
  );
  const { selectProps: shippersSelectProps } = useSelectScrollSearch({
    resource: RESOURCES.SHIPPERS,
    optionLabel: (item: any) => item.name,
  });
  const { selectProps: ticketsSelectProps } = useSelectScrollSearch(
    {
      resource: RESOURCES.TICKETS,
      optionLabel: (item: any) =>
        `${item.id} - ${item.title ? item.title : item.ticket_title_str ? item.ticket_title_str : '-'}`,
      optionValue: (item: any) => item.id,
      meta: { is_open: true },
    },
    { saveItem: true },
  );
  const isLoading = useMemo(
    () => companySelectProps.loading || shippersSelectProps.loading || ticketsSelectProps.loading,
    [companySelectProps.loading, shippersSelectProps.loading, ticketsSelectProps.loading],
  );
  const { initialLoading } = useInitialLoading(isLoading);

  return (
    <div className="ReceptionSection MainSection">
      {initialLoading ? (
        <SpinLoading />
      ) : (
        <Outlet context={{ companySelectProps, shippersSelectProps, ticketsSelectProps }} />
      )}
    </div>
  );
};

export default ReceptionSection;
